import type { components, paths } from "@/api-schema";
import { alphartisApiAxios } from "@/config/axios";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { OPEN_POSITION_RESOURCE } from "./use-open-position-search.query";

export const OPEN_POSITION_DUNNING_BLOCK_API_PATH =
  `/v1/${OPEN_POSITION_RESOURCE}/{openPositionUuid}/dunning-block` as const;

export const getOpenPositionDunningBlockPath = (openPositionUuid: string) =>
  `/v1/${OPEN_POSITION_RESOURCE}/${openPositionUuid}/dunning-block`;

export type OpenPositionDunningBlock = components["schemas"]["OpenPositionDunningBlock"];
export type OpenPositionDunningBlockBody =
  paths[typeof OPEN_POSITION_DUNNING_BLOCK_API_PATH]["post"]["requestBody"]["content"]["application/json"];

interface Variables {
  openPositionUuid: string;
  body: OpenPositionDunningBlockBody;
}

export function useOpenPositionDunningBlockCreateMutation() {
  const queryClient = useQueryClient();

  return useMutation<OpenPositionDunningBlock, Error, Variables>({
    mutationFn: async ({ openPositionUuid, body }) => {
      const response = await alphartisApiAxios.post<OpenPositionDunningBlock>(
        getOpenPositionDunningBlockPath(openPositionUuid),
        body,
      );

      return response.data;
    },
    onSettled: async () => {
      await queryClient.invalidateQueries({ queryKey: [OPEN_POSITION_RESOURCE] });
    },
  });
}
